import React, { useEffect, useMemo, useState } from 'react';
import './BackgroundImage.css';
import { STATIC_ICONS } from '../Constants';

const normalizeStoredImageUrl = (imageUrl) => {
  if (!imageUrl || typeof imageUrl !== 'string') return null;
  const normalized = imageUrl.trim();
  if (!normalized) return null;
  return /^blob:|^data:|^https?:/i.test(normalized) ? normalized : STATIC_ICONS + normalized;
};

const BackgroundImage = ({
  draggable,
  imageUrl,
  file,
  lightImageUrl,
  darkImageUrl,
  lightFile,
  darkFile,
  themeMode,
  useThemeImages,
}) => {
  const [cursorState, setCursorState] = useState('idle');
  const selectedFile = useThemeImages
    ? (themeMode === 'light' ? lightFile : darkFile)
    : (themeMode === 'light'
      ? (lightFile || file)
      : (darkFile || file));
  const selectedImageUrl = useThemeImages
    ? (themeMode === 'light' ? lightImageUrl : darkImageUrl)
    : (themeMode === 'light'
      ? (lightImageUrl || imageUrl)
      : (darkImageUrl || imageUrl));
  const [filePreviewUrl, setFilePreviewUrl] = useState(null);

  useEffect(() => {
    if (!(selectedFile instanceof Blob)) {
      setFilePreviewUrl(null);
      return undefined;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setFilePreviewUrl(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const resolvedImageUrl = useMemo(
    () => filePreviewUrl || normalizeStoredImageUrl(selectedImageUrl),
    [filePreviewUrl, selectedImageUrl]
  );

  const cursorClass = draggable
    ? (cursorState === 'grabbing' ? 'background-image--grabbing' : 'background-image--grab')
    : 'background-image--pointer';

  return (
    <div
      className={[
        "image-container",
        "background-image",
        cursorClass,
      ].filter(Boolean).join(" ")}
      onMouseDown={() => draggable && setCursorState('grabbing')}
      onMouseUp={() => draggable && setCursorState('grab')}
      onMouseLeave={() => draggable && setCursorState('grab')}
      draggable={draggable}
      onDragStart={(e) => {
        const id = e.target.closest('.widget')?.id;
        if (!id) return;
        const rect = e.target.getBoundingClientRect();
        const offsetX = e.clientX - rect.x;
        const offsetY = e.clientY - rect.y;
        let dragData = `background-image;${id};${offsetX};${offsetY};${id.startsWith('base') ? 'add' : 'move'}`;
        e.dataTransfer.setData('text/plain', dragData);
      }}
    >
      <div className="background-image-container">
        {resolvedImageUrl ? (
          <img
            src={resolvedImageUrl}
            alt="Background"
            className="background-image-preview"
          />
        ) : (
          <div className="placeholder-image">
            No Image Selected
          </div>
        )}
      </div>
    </div>
  );
};

export default BackgroundImage;
